import React, { useState } from 'react'
import { Card } from 'react-bootstrap';

const CurrencyExchange = () => {
    const [ amount, setAmount ] = useState(0)
    const [ fromCurrency, setFromCurrency ] = useState('')
    const [ toCurrency, setToCurrency ] = useState('')
    const [ convertedValue, setConvertedValue ] = useState(0)
 
    const exchangeRates = {
        USD: 1,
        EUR: 0.92,
        GBP: 0.79,
        INR: 83.3,
        JPY: 155.6,
    }

    const convertCurrency = (amount, from, to) => {
        const inUSD = amount / exchangeRates[from]
        const convertedAmount = (inUSD * exchangeRates[to]).toFixed(2)

        setConvertedValue(convertedAmount)
    }

  return (
    <Card className='card-background'>
        <div className='currency-exchange-field'>
            <input className='from-currency-field' type="number" placeholder='Enter your number here' onBlur={e => setAmount(e.target.value)}></input>
            <select
                className="from-currency-dropdown"
                value={fromCurrency}
                onChange={e => setFromCurrency(e.target.value)}
            >
                <option value="">-- Select Currency --</option>
                <option value="USD">USD</option>
                <option value="EUR">EUR</option>
                <option value="GBP">GBP</option>
                <option value="INR">INR</option>
                <option value="JPY">JPY</option>
            </select>
            <select
                className="to-currency-dropdown"
                value={toCurrency}
                onChange={e => setToCurrency(e.target.value)}
            >
                <option value="">-- Select Currency --</option>
                <option value="USD">USD</option>
                <option value="EUR">EUR</option>
                <option value="GBP">GBP</option>
                <option value="INR">INR</option>
                <option value="JPY">JPY</option>
            </select>
        </div>
        <div className='currency-result-field'>
            <button className='convert-currency-button' onClick={() => convertCurrency(Number(amount), fromCurrency, toCurrency)}>Convert</button>
        </div>
        <div className='currency-result-field'>
            <input className='to-currency-field' value={convertedValue}></input>
        </div>
    </Card>
  )
}

export default CurrencyExchange